import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../index.css';
import { ToastContainer, toast } from 'react-toastify';
import { Constants } from '../../lib/const/constants';
import getCurrencySymbol from '../../lib/currenyUtils';
import axios from 'axios';

const emptyRow = () => ({
  account_number: '',
  sort_code: '',
  reference: '',
  amount: '',
  beneficiary_name: '',
});

const emptyErrors = () => ({
  account_number: '',
  sort_code: '',
  reference: '',
  amount: '',
  beneficiary_name: '',
});

const FasterPayment = () => {
  const navigate = useNavigate();

  const [rows, setRows] = useState([emptyRow()]);
  const [errors, setErrors] = useState([emptyErrors()]);

  const [availableBalances, setAvailableBalances] = useState(0);
  const [balanceLoading, setBalanceLoading] = useState(false);


  useEffect(() => {
    getBalances();
  }, []);


    // Amount Format

    const numberWithCommas = (value) => {
    if (value === null || value === undefined || value === '') {
      return '0';
    }

    const valueStr = String(value);
    const [integerPart, decimalPart] = valueStr.split('.');

    const formattedInteger =
      integerPart.length >= 5
        ? integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        : integerPart;

    return decimalPart !== undefined
      ? `${formattedInteger}.${decimalPart}`
      : formattedInteger;
  };

  const getBalances = async () => {
    if (balanceLoading) return;

    setBalanceLoading(true);

    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');

    console.log("workspace", login_workspaces_id);
    console.log("token", login_token);

    try {
      const resp = await axios.get(
        Constants.BASE_URL +
        'API-FX-231-GET-WALLET-BALANCES/' +
        login_workspaces_id +
        '?currency=GBP',
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        }
      );

      const balArray = Object.values(resp.data);

      const gbpBalance = balArray.find(
        (b) => b?.currency === 'GBP'
      );

      const mainBalance = gbpBalance ? gbpBalance.balance : 0;

      const used =
        resp.data.used_balances?.GBP
          ? resp.data.used_balances.GBP
          : 0;

      const avail = parseFloat(mainBalance - used).toFixed(2);

      setAvailableBalances(avail < 0 ? 0 : Number(avail));
    } catch (err) {
      console.log(err);
      toast.error('Failed to fetch balance');
    } finally {
      setBalanceLoading(false);
    }
  };

  const validateField = (name, value) => {
    // const referenceRegex = /^[a-zA-Z0-9\s-]+$/;

    switch (name) {
      case 'account_number':
        if (!value) return 'Account number is required';
        if (!/^\d{8}$/.test(value)) return 'Account number must be exactly 8 digits';
        return '';

      case 'sort_code':
        if (!value) return 'Sort code is required';
        if (!/^\d{6}$/.test(value)) {
          // return 'Sort code must contain exactly 6 numeric characters';
          return '';
        }
         return '';

      case 'beneficiary_name':
        // Alphanumeric, max 80 characters
        if (!value) return 'Beneficiary name is required';
        if (value.length > 80) return 'Beneficiary name must not exceed 80 characters';
        if (!/^[a-zA-Z0-9\s]+$/.test(value))
          return 'Beneficiary name must be alphanumeric only';
        return '';

      case 'amount':
        if (!value) return 'Amount is required';
        if (isNaN(value) || Number(value) <= 0) return 'Enter a valid amount';
        if (!/^\d+(\.\d{1,2})?$/.test(value))
          return 'Amount can have at most 2 decimal places';
        return '';

      case 'reference':
        if (!value) return 'Reference is required';

        if (!/^[A-Za-z0-9 -]+$/.test(value)) {
          return 'Only alphanumeric, space and hyphen are allowed';
        }
         return '';


      default:
        return '';
    }
  };

  //  Handle change
  const handleChange = (index, e) => {
    const { name, value } = e.target;

    const newRows = [...rows];
    newRows[index][name] = value;
    setRows(newRows);

    const newErrors = [...errors];
    newErrors[index][name] = validateField(name, value);
    setErrors(newErrors);
  };

  const handleAccountNumberChange = (index, e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 8);
    const newRows = [...rows];
    newRows[index]['account_number'] = value;
    setRows(newRows);

    const newErrors = [...errors];
    newErrors[index]['account_number'] = validateField('account_number', value);
    setErrors(newErrors);
  };

  // const handleSortCodeChange = (index, e) => {
  //   const value = e.target.value.replace(/\D/g, '').slice(0, 6);
  //   const newRows = [...rows];
  //   newRows[index]['sort_code'] = value;
  //   setRows(newRows);

  //   const newErrors = [...errors];
  //   newErrors[index]['sort_code'] = validateField('sort_code', value);
  //   setErrors(newErrors);
  // };


  const handleAmountChange = (index, e) => {
    let value = e.target.value;

    // Allow only digits and a single dot
    value = value.replace(/[^0-9.]/g, '');

    // Allow only one decimal point — remove extras
    const dotIndex = value.indexOf('.');
    if (dotIndex !== -1) {
      value = value.slice(0, dotIndex + 1) + value.slice(dotIndex + 1).replace(/\./g, '');
      // Strictly block if more than 2 digits after decimal
      const afterDot = value.slice(dotIndex + 1);
      if (afterDot.length > 2) return;
    }

    const newRows = [...rows];
    newRows[index]['amount'] = value;
    setRows(newRows);

    const newErrors = [...errors];
    newErrors[index]['amount'] = validateField('amount', value);
    setErrors(newErrors);
  };


  // const handleBeneficiaryNameChange = (index, e) => {
  //   // Allow alphanumeric and spaces only, enforce max 80
  //   let value = e.target.value.replace(/[^a-zA-Z0-9\s]/g, '').slice(0, 80);

  //   const newRows = [...rows];
  //   newRows[index]['beneficiary_name'] = value;
  //   setRows(newRows);

  //   const newErrors = [...errors];
  //   newErrors[index]['beneficiary_name'] = validateField('beneficiary_name', value);
  //   setErrors(newErrors);
  // };


  const handleAmountBlur = (index) => {
    const value = rows[index]['amount'];
    if (value === '' || isNaN(value) || Number(value) <= 0) return;

    const formatted = parseFloat(value).toFixed(2);

    const newRows = [...rows];
    newRows[index]['amount'] = formatted;
    setRows(newRows);

    const newErrors = [...errors];
    newErrors[index]['amount'] = validateField('amount', formatted);
    setErrors(newErrors);
  };


  const handleAdd = () => {
    setRows([...rows, emptyRow()]);
    setErrors([...errors, emptyErrors()]);
  };

  const handleRemove = (index) => {
    if (rows.length === 1) return;

    setRows(rows.filter((_, i) => i !== index));
    setErrors(errors.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    const newErrors = rows.map((row) => {
      return {
        account_number: validateField(
          'account_number',
          row.account_number
        ),
        sort_code: validateField(
          'sort_code',
          row.sort_code
        ),
        reference: validateField(
          'reference',
          row.reference
        ),
        amount: validateField('amount', row.amount),
        beneficiary_name: validateField(
          'beneficiary_name',
          row.beneficiary_name
        ),
      };
    });

    setErrors(newErrors);

    const hasAnyError = newErrors.some((rowErr) =>
      Object.values(rowErr).some((msg) => msg !== '')
    );

    if (hasAnyError) return;

    const totalAmount = rows.reduce(
      (sum, row) => sum + Number(row.amount || 0),
      0
    );

    if (Number(totalAmount) > Number(availableBalances)) {
      toast.error('Insufficient funds to complete the faster payment');
      return;
    }

    try {
      navigate('/FasterPayemtPreviewScreen', {
        state: {
          previewData: rows,
          availableBalance: availableBalances,
        },
      });
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <ToastContainer />

      <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-2xl p-6">

        <h2 className="text-2xl font-semibold mb-6 text-gray-800">
          Faster Payment
        </h2>


        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
          {balanceLoading ? (
            <span style={{ fontSize: 13, color: '#9CA3AF' }}>Loading balance…</span>
          ) : (
            <>
              <div
                style={{
                  border: '1px solid #E6E5E5',
                  borderRadius: '10px 0 0 10px',
                  padding: '10px 28px',
                  fontSize: 14,
                  fontWeight: 400,
                  color: '#676F7D',
                  borderRight: 'none',
                }}
              >
                Available Balance:{' '}
                <strong style={{ color: '#101828' }}>
                   {getCurrencySymbol('GBP')} {numberWithCommas(availableBalances.toFixed(2))}
                  {/* {getCurrencySymbol('GBP')} {availableBalances.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} */}
                </strong>
              </div>
              <div
                style={{
                  border: '1px solid #E6E5E5',
                  borderRadius: '0 10px 10px 0',
                  padding: '10px 28px',
                  fontSize: 14,
                  fontWeight: 400,
                  color: '#676F7D',
                }}
              >
                Total Amount:{' '}
                <strong style={{ color: '#101828' }}>
                  {getCurrencySymbol('GBP')}{' '}
                  {rows.reduce((s, r) => s + Number(r.amount || 0), 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </strong>
              </div>
            </>
          )}
        </div>


        {rows.map((row, index) => (
          <div
            key={index}
            className="grid grid-cols-1 md:grid-cols-6 gap-4 mb-4 border p-4 rounded-xl bg-gray-50"
          >
            {/* Account Number */}
            <div className="flex flex-col">
              <input
                type="text"
                name="account_number"
                placeholder="Account Number"
                value={row.account_number}
                onChange={(e) =>
                  handleAccountNumberChange(index, e)
                }
                className={`Input_FasterPayment ${errors[index]?.account_number
                  ? 'border-red-500'
                  : ''
                  }`}
              />

              {errors[index]?.account_number && (
                <span className="text-red-500 text-xs mt-1">
                  {errors[index].account_number}
                </span>
              )}
            </div>

            <div className="flex flex-col">
              <input
                type="text"
                name="sort_code"
                placeholder="Sort Code"
                value={row.sort_code}
                maxLength={6}
                onChange={(e) => {
                  // Allow only numeric characters
                  const numericValue = e.target.value.replace(/\D/g, '');

                  handleChange(index, {
                    target: {
                      name: e.target.name,
                      value: numericValue,
                    },
                  });
                }}
                className={`Input_FasterPayment ${errors[index]?.sort_code ? 'border-red-500' : ''
                  }`}
              />

              {errors[index]?.sort_code && (
                <span className="text-red-500 text-xs mt-1">
                  {errors[index].sort_code}
                </span>
              )}
            </div>

            <div className="flex flex-col">
              <input
                type="text"
                name="reference"
                placeholder="Reference"
                value={row.reference}
                onChange={(e) => {
                  const filteredValue = e.target.value.replace(/[^A-Za-z0-9 -]/g, '');

                  handleChange(index, {
                    target: {
                      name: e.target.name,
                      value: filteredValue,
                    },
                  });
                }}
                className={`Input_FasterPayment ${errors[index]?.reference ? 'border-red-500' : ''
                  }`}
              />

              {errors[index]?.reference && (
                <span className="text-red-500 text-xs mt-1">
                  {errors[index].reference}
                </span>
              )}
            </div>

            <div className="flex flex-col">
              <input
                type="text"
                name="amount"
                placeholder="Amount"
                value={row.amount}
                onChange={(e) => handleAmountChange(index, e)}
                onBlur={() => handleAmountBlur(index)}
                className={`Input_FasterPayment ${errors[index]?.amount ? 'border-red-500' : ''
                  }`}
              />

              {errors[index]?.amount && (
                <span className="text-red-500 text-xs mt-1">
                  {errors[index].amount}
                </span>
              )}
            </div>

            <div className="flex flex-col">
              <input
                type="text"
                name="beneficiary_name"
                placeholder="Beneficiary Name"
                value={row.beneficiary_name}
                onChange={(e) => handleChange(index, e)}
                className={`Input_FasterPayment ${errors[index]?.beneficiary_name
                  ? 'border-red-500'
                  : ''
                  }`}
              />

              {errors[index]?.beneficiary_name && (
                <span className="text-red-500 text-xs mt-1">
                  {errors[index].beneficiary_name}
                </span>
              )}
            </div>

            {index > 0 ? (
              <button
                onClick={() => handleRemove(index)}
                className="bg-red-500 text-white px-3 py-2 rounded-lg hover:bg-red-600 transition self-start"
              >
                Remove
              </button>
            ) : (
              <div />
            )}
          </div>
        ))}

        <div className="flex justify-between mt-6">
          <button
            onClick={handleAdd}
            className="px-5 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
          >
            + Add More
          </button>

          <button
            onClick={handleSubmit}
            disabled={balanceLoading}
            className="px-6 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition disabled:opacity-50"
          >
            {balanceLoading ? 'Loading...' : 'Submit'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FasterPayment;